import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\ElectronicSignature\AddSignersToYouSign::__invoke
* @see app/Http/Controllers/ElectronicSignature/AddSignersToYouSign.php
* @route '/api/electronic-signature/{electronicSignature}/add-signers-to-yousign'
*/
const AddSignersToYouSign = (args: { electronicSignature: string | number | { id: string | number } } | [electronicSignature: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: AddSignersToYouSign.url(args, options),
    method: 'post',
})

AddSignersToYouSign.definition = {
    methods: ["post"],
    url: '/api/electronic-signature/{electronicSignature}/add-signers-to-yousign',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\ElectronicSignature\AddSignersToYouSign::__invoke
* @see app/Http/Controllers/ElectronicSignature/AddSignersToYouSign.php
* @route '/api/electronic-signature/{electronicSignature}/add-signers-to-yousign'
*/
AddSignersToYouSign.url = (args: { electronicSignature: string | number | { id: string | number } } | [electronicSignature: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { electronicSignature: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { electronicSignature: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            electronicSignature: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        electronicSignature: typeof args.electronicSignature === 'object'
        ? args.electronicSignature.id
        : args.electronicSignature,
    }

    return AddSignersToYouSign.definition.url
            .replace('{electronicSignature}', parsedArgs.electronicSignature.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ElectronicSignature\AddSignersToYouSign::__invoke
* @see app/Http/Controllers/ElectronicSignature/AddSignersToYouSign.php
* @route '/api/electronic-signature/{electronicSignature}/add-signers-to-yousign'
*/
AddSignersToYouSign.post = (args: { electronicSignature: string | number | { id: string | number } } | [electronicSignature: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: AddSignersToYouSign.url(args, options),
    method: 'post',
})

export default AddSignersToYouSign